import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from '../http.service';
import { SnackbarService } from '../snackbar.service';
import { ValidationService } from '../validation.service';
import { Messages } from '../constants/messages';
import { Message } from '@angular/compiler/src/i18n/i18n_ast';

@Component({
  selector: 'app-tax-settings',
  templateUrl: './tax-settings.component.html',
  styleUrls: ['./tax-settings.component.scss']
})
export class TaxSettingsComponent implements OnInit { 
  taxData: any = {
    tax_details: []
  };
  bankData: any = {
    bank_account_details: []
  };
  gstVat = '';
  panCr = '';
  accountNo = '';
  branch = '';
  uniqueNo = '';
showLoader  = false;
messages = new Messages();
helpData = [
  { head: 'Head', data: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry' },
  { head: 'Head', data: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry' },
];
constructor(private http: HttpService, private snackBar: SnackbarService, private valid: ValidationService) { }

ngOnInit() {
  this.getDetails();
}
getDetails() {
  this.showLoader = true;
  this.http.get('carrier').subscribe(
    (data: any) => {
      if (data.statusCode === 200) {
        this.showLoader = false;
        this.gstVat = data.data.tax_details[0].value;
        this.panCr = data.data.tax_details[1].value;
        this.accountNo = data.data.bank_account_details[0].value;
        this.branch = data.data.bank_account_details[1].value;
        this.uniqueNo = data.data.bank_account_details[2].value;
      }
    }
  );
}
validateGst() {
    if (this.valid.isEmpty(this.gstVat) || this.valid.isEmpty(this.panCr)) {
      this.snackBar.openSnackBar(this.messages.TAX.allFields, '', 'err');
      return false;
    } else if (environment.country == 'IN' && !this.valid.isGst(this.gstVat)) {
      this.snackBar.openSnackBar(this.messages.TAX.validGst, '', 'err');
      return false;
    } else if (environment.country == 'IN' && !this.valid.isPan(this.panCr)) {
      this.snackBar.openSnackBar(this.messages.TAX.pan, '', 'err');
      return false;
    }
    return true;
}
validateBank() {
  if (this.valid.isEmpty(this.accountNo) || this.valid.isEmpty(this.branch) || this.valid.isEmpty(this.uniqueNo)) {
    this.snackBar.openSnackBar(this.messages.TAX.allFields, '', 'err');
    return false;
  } else if ( (environment.country == 'SA' || environment.country == 'BR') && !this.valid.isIban(this.uniqueNo)) {
    this.snackBar.openSnackBar(this.messages.TAX.iban, '', 'err');
    return false;
  } else if (environment.country == 'IN' && !this.valid.isIfsc(this.uniqueNo)) {
    this.snackBar.openSnackBar(this.messages.TAX.ifsc, '', 'err');
    return false;
  }
  return true;
}
submitGst() {
  this.taxData.tax_details = [];
  if (this.validateGst()) {
    if (environment.country === 'IN') {
    this.taxData.tax_details.push({label: 'gst', value: this.gstVat});
    this.taxData.tax_details.push({label: 'pan', value: this.panCr});
   }
    if (environment.country === 'SA' || environment.country === 'BR' ) {
    this.taxData.tax_details.push({label: 'vat', value: this.gstVat});
    this.taxData.tax_details.push({label: 'cr_number', value: this.panCr});
   }
    this.http.post('carrier/tax_details', this.taxData).subscribe(
     (data: any) => {
       if (data.statusCode === 200) {
        this.snackBar.openSnackBar(this.messages.TAX.success, '');
       }
     },
     (err: any) => {
       this.snackBar.openSnackBar(err.error.message, '', 'err');
     }
   );
 }

}
submitBank() {
  this.bankData.bank_account_details = [];
  if (this.validateBank()) {

    if (environment.country === 'IN') {
      this.bankData.bank_account_details.push({label: 'account_number', value: this.accountNo});
      this.bankData.bank_account_details.push({label: 'branch', value: this.branch});
      this.bankData.bank_account_details.push({label: 'IFSC', value: this.uniqueNo});
     }
    if (environment.country === 'SA' || environment.country === 'BR' ) {
    this.bankData.bank_account_details.push({label: 'account_number', value: this.accountNo});
    this.bankData.bank_account_details.push({label: 'bank_identifier', value: this.branch});
    this.bankData.bank_account_details.push({label: 'IBAN', value: this.uniqueNo});
    }
    this.http.post('carrier/bank_details', this.bankData).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
         this.snackBar.openSnackBar(this.messages.TAX.success, '');
        }
      },
      (err: any) => {
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
}
}
